import Link from 'next/link';

import { Heading } from '@/components/ui/Heading';
import { MenuItem } from '@/core/types/menuApi';
import Image from 'next/image';
import { Settings } from '@/core/types/landing';

type FooterListProps = {
  footerItems: MenuItem[];
  setting: Settings
};

export default function FooterList({ footerItems, setting }: FooterListProps) {

  return (
    <div className="grid grid-cols-4 space-y-8 md:space-y-0">
      {footerItems.map(item => (
        <div
          key={item.id}
          className="col-span-4 px-3 lg:col-span-1 md:col-span-2"
        >
          <Heading level={4} className="mb-3">
            {item.title}
          </Heading>
          <ul className="space-y-1">
            {item.children!.map(child => (
              <li key={child.id}>
                <Link href={child.link} className="text-primary-600 text-xs">
                  {child.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}


      <div className='size-30'>
        <a
          referrerPolicy="origin"
          target="_blank"
          href={`https://trustseal.enamad.ir/?id=${process.env.ENAMAD_ID}&Code=${process.env.ENAMAD_CODE}`}
        >
          <img
            referrerPolicy="origin"
            src={`https://trustseal.enamad.ir/logo.aspx?id=${process.env.ENAMAD_ID}&Code=${process.env.ENAMAD_CODE}`}
            alt=""
            style={{ cursor: 'pointer' }}
            //@ts-ignore
            code={process.env.ENAMAD_CODE}
          />
        </a>
      </div>


    </div>
  );
}
